import "../node_modules/algoliasearch/dist/algoliasearchLite.min.js"
import buildSearchModule from "./Search.js"


window.algoliasearch = require("../node_modules/algoliasearch/dist/algoliasearchLite.min.js");

const Search = buildSearchModule(window.algoliasearch);
export default Search;
